var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container account-form-page"},[_c('div',{staticClass:"card card-page"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('account-data',{attrs:{"id":_vm.id}})],1),_c('div',{staticClass:"card-footer"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h1',{staticClass:"card-title"},[_vm._v("Conta do paciente")])])
}]

export { render, staticRenderFns }